import React from 'react'
import Lottie from "react-lottie-player";
import grouping_loading from "../../assets/grouping_loading.json"
import "../../styles/LoadingPage.scss"
import { useTranslation } from 'react-i18next';

function LoadingPage({error}) {
  const { t } = useTranslation();
  return (
    <div className="LoadingPage">
        <div className="LoadingPage_1">
        <Lottie
            loop
            animationData={grouping_loading}
            play
            style={{ width: "100%", height: "100%" }}
        />
        </div>
        {error && <div className="LoadingPage_2">{t('common.internetError')}</div>}

    </div>
  )
}

export default LoadingPage
